const SvgPeerVerifyImg=()=>{
return(
<>
<svg
                            width="21"
                            height="11"
                            viewBox="0 0 21 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="inline-block"
                          >
                            <path
                              d="M4.66669 11L14 1.57143L12.4444 0L4.66665 7.85719L1.55555 4.71434L0 6.28577L4.66669 11Z"
                              fill="#63BD43"
                            />
                            <path
                              d="M11.6667 11L21 1.57143L19.4444 0L11.6667 7.85719L8.55555 4.71434L7 6.28577L11.6667 11Z"
                              fill="#63BD43"
                            />
                          </svg>
</>
);
};
export default SvgPeerVerifyImg;